'use client';
import { useHasSubscription } from '~features/tags';

import { useGetPromoEventData } from './useGetPromoEventData';

export const usePromoEventSubscription = () => {
	const { isResolved, data } = useGetPromoEventData();
	const [hasSubscription, isLoading] = useHasSubscription();
	const subscriptionOffer = data?.offers.find(
		(offer) => offer.type === 'Subscription'
	);
	const offersSpecialMembership =
		!hasSubscription && subscriptionOffer?.buttonIconUrl;

	return {
		promoMembershipActive: !isLoading && isResolved && offersSpecialMembership,
		data: {
			promocode: subscriptionOffer?.promoCode,
			buttonImageUrl: subscriptionOffer?.buttonIconUrl,
		},
		activeOnPages: subscriptionOffer?.activeOnPages,
		isLoading,
	};
};
